<ng-container>
  <title
    direction="left"
    [style]="{
      'font-size': '16px',
      color: '#3376F6',
      'margin-bottom': '1.5rem',
    }"
  >
    #7 SCPI (Société Civile de Placement Immobilier)
  </title>

  <div class="formControl mt">
    <div class="row">
      <div class="col col-md-12">
        <title
          [style]="{ fontSize: '16px', color: '#2E557A', fontWeight: '500' }"
          direction="left"
        >
          Le placement en SCPI offre une garantie en capital.
        </title>
      </div>
      <div class="col col-md-12">
        <pr-input-radio
          formControlName="scpi1"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
          [columns]="3"
        >
        </pr-input-radio>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <title
          [style]="{ fontSize: '16px', color: '#2E557A', fontWeight: '500' }"
          direction="left"
        >
          Les loyers de SCPI ne sont pas totalement garantis.
        </title>
      </div>
      <div class="col col-md-12 clear-m">
        <pr-input-radio
          formControlName="scpi2"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
          [columns]="3"
        >
        </pr-input-radio>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <title
          [style]="{ fontSize: '16px', color: '#2E557A', fontWeight: '500' }"
          direction="left"
        >
          Les parts de SCPI sont des supports de placement à long terme.
        </title>
      </div>
      <div class="col col-md-12 clear-m">
        <pr-input-radio
          formControlName="scpi3"
          direction="column"
          [isDefault]="false"
          [toggle]="true"
          [options]="options"
          [columns]="3"
        >
        </pr-input-radio>
      </div>
    </div>
  </div>
</ng-container>
